export function createClasses(className: string, prefix = 'adex'): string {
  return `${prefix}__${className}`
}
